<template>
	<div class="module">
		<div class="module-header">
			<h2 class="heading-5 text-transform-capitalize">{{ section.name }}</h2>
		</div>
		<div class="module-section">
			<ul v-for="(article, index) in section.articles.slice(0, maxListLength)" :key="index" class="ul delta-md">
				<li class="line-height-125" data-test="article">
					<BaseLink
						:link="{ router: 'help-center-article', params: { articleId: article.id } }"
						class="headline-link"
					>
						<span>{{ article.title }}</span>
					</BaseLink>
				</li>
			</ul>
			<p v-if="section.articles.length > maxListLength" class="pl-100 body-lg-md">
				<BaseCtaLink
					classes="see-all-articles"
					data-test="see-all-articles-button"
					:link="{
						router: 'help-center-section',
						params: { sectionId: section.id },
						text: `See all ${section.articles.length} articles`
					}"
				/>
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
import { HelpCenterSection } from 'types/help-center';
import { ref } from 'vue';

interface Props {
	maxLength?: number;
	section: HelpCenterSection;
}

const props = withDefaults(defineProps<Props>(), {
	maxLength: 0
});

const maxListLength = ref(props.maxLength);

function setup(): void {
	if (!maxListLength.value) {
		maxListLength.value = props.section.articles.length;
	}
}
setup();
</script>
